/* eslint-disable no-unused-vars */
import React, { useEffect, useCallback,useState } from 'react';
import { Space, Tag, Tooltip } from 'antd';
import useListFilters from '../../hooks/useListFilters';
import ListPage from '../../components/core/ListPage';
import { useInvoiceList } from '../../hooks/invoice/useInvoiceList';
import InvoicePreviewDownloader from '../../components/invoices/InvoicePreviewDownloader';
import {
  getInvoiceTypeText,
} from '../../utils/clinic';
import PaypalPaymentButton from '../../components/case/PaypalPaymentButton';
import { PaymentFor } from '../../appContants';
import { getMonthTitleFromMonthNumber } from '../../utils/date';
const BREAD_CRUMBS = [
  { label: 'Accounting', to: '/user/invoicelist' },
  { label: 'Invoice List', to: '/user/invoicelist' },
];

export const InvoiceList = () => {
  const { data, getList } = useInvoiceList();
  const {
    loading,
    search,
    tableParams,
    setLoading,
    setSearch,
    setTableParams,
  } = useListFilters();
  const [statusFilter, setStatusFilter] = useState('all');
  // Table
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getList({
        status: statusFilter !== 'all' ? statusFilter : undefined, // 👈 apply filter
        search,
        page: tableParams.pagination?.current,
        limit: tableParams.pagination?.pageSize,
        sortOrder: tableParams?.sortOrder,
        sortBy: tableParams?.sortField,
      });
      setLoading(false);
      // Update table params
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: response.totalItems,
        },
      });
    } catch (error) {
      setLoading(false);
    }
  }, [
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    search,
    statusFilter
  ]);

  const handleTableChange = (pagination, _, sorter) => {
    setTableParams({
      pagination,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };

  useEffect(() => {
    reload();
  }, [
    statusFilter,
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    search,
  ]);
  const handleStatusChange = (value) => {
    setStatusFilter(value);
    setTableParams((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        current: 1,
      },
    }));
  };

  const columns = [
    {
      title: 'Invoice No.',
      dataIndex: 'invoiceNo',
      sorter: true,
      render: (_, { invoiceNo }) => {
        if (!invoiceNo) return undefined;
        const parts = invoiceNo.split('-');
        return parts.length > 1 ? parts.slice(1).join('-') : invoiceNo;
      },
    },
    {
      title: 'Invoice Type',
      dataIndex: 'invoiceType',
      sorter: true,
      render: (_, { invoiceType }) => {
        return invoiceType ? getInvoiceTypeText(invoiceType) : undefined;
      },
    },
    {
      title: 'Invoice Amount',
      dataIndex: 'amount',
      sorter: true,
      render: (_, { amount }) => {
        return amount;
      },
    },
    {
      title: 'Month-Year',
      dataIndex: 'yearNumber',
      sorter: true,
      render: (_, { monthNumber, yearNumber }) => {
        return monthNumber >= 0 && yearNumber
          ? `${getMonthTitleFromMonthNumber(monthNumber)}-${yearNumber}`
          : undefined;
      },
    },
    {
      title: 'Payment Status',
      dataIndex: 'paymentId',
      render: (_, record, index) => {
        const services = record?.invoiceCaseServices || [];
        let statusMeta = {
          color: 'red',
          text: 'UN-PAID',
        };

        if (services.length > 0) {
          const allPaid = services.every((service) => service.paymentStatus === true);

          if (allPaid) {
            statusMeta = {
              color: 'green',
              text: record?.paymentPlatform
                ? `Paid with ${record.paymentPlatform}`
                : 'Paid with CHEQUE',
            };
          }
        }

        return (
          <Tag color={statusMeta?.color} key={index}>
            {statusMeta?.text}
          </Tag>
        );
      },
    },
    {
      title: 'Actions',
      dataIndex: '',
      render: (_, record) => {
        const services = record?.invoiceCaseServices || [];
        const allServicesPaid =
          services.length > 0 &&
          services.every((service) => service.paymentStatus === true);

        return (
          <Space size="middle">
            <InvoicePreviewDownloader
              invoiceId={record?.invoiceId}
              invoiceNo={record?.invoiceNo}
            />
            {allServicesPaid ? null : (
              <Tooltip title="Make Payment">
                <PaypalPaymentButton
                  paymentFor={PaymentFor.INVOICE}
                  loading={loading === record?.invoiceId}
                  recordId={record?.invoiceId}
                  type="primary"
                  htmlType="button"
                  disabled={!!loading}
                  title={'Make Payment'}
                  icon={<i className="fab fa-paypal" />}
                  onMarkAsSubmitted={reload}
                />
              </Tooltip>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <ListPage
      title={'Invoice List'}
      data={data?.items || []}
      columns={columns}
      loading={loading}
      pagination={tableParams.pagination}
      rowKey={(record) => record?.invoiceId}
      onRefresh={reload}
      onSearch={setSearch}
      onTableChange={handleTableChange}
      breadCrumbItems={BREAD_CRUMBS}
      hideAddAction
      showStatusFilter   // 👈 new
      onStatusChange={handleStatusChange} // 👈 new
    />
  );
};
